<h1 id="title" class="title">Verify Email</h1>
<p class="sub-title">Check your inbox and verify your email to continue.</p>

<nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
  <p class="alert-title"><b>Oh snap!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
  </ul>
</nb-alert>

<nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert">
  <p class="alert-title"><b>Hooray!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
  </ul>
</nb-alert>

<form #verifyEmailForm="ngForm" aria-labelledby="title">
  <div class="form-control-group">
    <label class="label" for="input-email">Email address:</label>
    <input nbInput
           fullWidth
           [(ngModel)]="email"
           #emailModel="ngModel"
           name="email"
           id="input-email"
           pattern=".+@.+\..+"
           placeholder="Email address"
           fieldSize="large"
           [disabled]="true"
           [status]="emailModel.dirty ? (emailModel.invalid ? 'danger' : 'success') : 'basic'"
           required
           [attr.aria-invalid]="emailModel.invalid && emailModel.touched ? true : null">
  </div>

  <div class="form-control-group">
    <label class="label" for="input-code">Verification code (optional):</label>
    <input nbInput
           fullWidth
           [(ngModel)]="code"
           name="code"
           id="input-code"
           placeholder="Code from verification link"
           fieldSize="large">
  </div>

  <button nbButton
          fullWidth
          status="primary"
          size="large"
          type="button"
          [disabled]="submitted || !email || !code"
          (click)="verifyEmail()">
    Verify email
  </button>

  <button nbButton
          fullWidth
          status="info"
          size="large"
          type="button"
          [disabled]="submitted || !email"
          (click)="resendVerificationEmail()">
    Resend verification email
  </button>

  <button nbButton
          fullWidth
          status="success"
          size="large"
          type="button"
          [disabled]="submitted"
          (click)="continueLogin()">
    Continue to login
  </button>
</form>
